import {NgModule} from "@angular/core";
import {SettingsLanguagesComponent} from "./languages/languages.component";
import {SettingsUsersComponent} from "./users/users.component";
import {LanguagesPipe} from "./languages/languages.pipe";
import {UsersPipe} from "./users/users.pipe";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {UserModal} from "./users/components/user.modal";
import {RolesComponent} from "./roles/roles.component";
import {RoleModal} from "./roles/components/role.modal";
import {PermissionModal} from "./roles/components/permission.modal";
import {NgDragDropModule} from "ng-drag-drop";
import {CompaniesComponent} from "./companies/companies.component";
import {CompanyModal}             from "./companies/components/company.modal";
import {CompaniesPipe}            from "./companies/companies.pipe";
import {LanguageIdFilterPipe}     from "./users/languageIdFilter.pipe";
import {routing}                  from './settings.routing';
import {MessagecentralsComponent} from './messagecentrals/messagecentrals.component';
import {MessagecentralModal}      from './messagecentrals/components/messagecentral.modal';
import {BasesComponent}           from "./bases/bases.component";
import {NgSelectModule}           from "@ng-select/ng-select";
import {SharedModule}             from '../shared/shared.module';

@NgModule({
    imports : [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule.forRoot(),
        NgDragDropModule.forRoot(),
        NgSelectModule,
        SharedModule,
        routing
    ],
    declarations : [
        SettingsLanguagesComponent,
        SettingsUsersComponent,
        LanguagesPipe,
        UsersPipe,
        UserModal,
        RolesComponent,
        RoleModal,
        PermissionModal,
        CompaniesComponent,
        CompanyModal,
        CompaniesPipe,
        LanguageIdFilterPipe,
        MessagecentralsComponent,
        MessagecentralModal,
        BasesComponent
    ],
    entryComponents : [
        UserModal,
        RoleModal,
        PermissionModal,
        CompanyModal,
        MessagecentralModal
    ]
})

export class SettingsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/settings.module.ts